// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/plate_well_config.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_quanterix_common_extensions_v1_field_options } from "../../../common/extensions/v1/field_options_pb";
import type { SampleType } from "../../../common/types/v1/sample_type_pb";
import { file_quanterix_common_types_v1_sample_type } from "../../../common/types/v1/sample_type_pb";
import type { WellReadStatus } from "../../../common/types/v1/well_read_status_pb";
import { file_quanterix_common_types_v1_well_read_status } from "../../../common/types/v1/well_read_status_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/plate_well_config.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_plate_well_config: GenFile = /*@__PURE__*/
  fileDesc("Cj9xdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvcGxhdGVfd2VsbF9jb25maWcucHJvdG8SJ3F1YW50ZXJpeC5zaW1vYV9vbmUuYW5hbHlzaXNfYXBwX2FwaS52MSLkAwoPUGxhdGVXZWxsQ29uZmlnEh4KAmlkGAEgASgJQg2CtRgJEgd3ZWxsX2lkSACIAQESGQoMd2VsbF9hZGRyZXNzGAIgASgJSAGIAQESHQoIYXNzYXlfaWQYAyABKAlCBoK1GAIYAUgCiAEBEh8KCmFzc2F5X25hbWUYBCABKAlCBoK1GAIYAUgDiAEBEhYKCXNhbXBsZV9pZBgFIAEoCUgEiAEBEhgKC3NhbXBsZV9uYW1lGAYgASgJSAWIAQESPwoLc2FtcGxlX3R5cGUYByABKA4yJS5xdWFudGVyaXguY29tbW9uLnR5cGVzLnYxLlNhbXBsZVR5cGVIBogBARJIChB3ZWxsX3JlYWRfc3RhdHVzGAggASgOMikucXVhbnRlcml4LmNvbW1vbi50eXBlcy52MS5XZWxsUmVhZFN0YXR1c0gHiAEBEhUKCGRpbHV0aW9uGAkgASgBSAiIAQFCBQoDX2lkQg8KDV93ZWxsX2FkZHJlc3NCCwoJX2Fzc2F5X2lkQg0KC19hc3NheV9uYW1lQgwKCl9zYW1wbGVfaWRCDgoMX3NhbXBsZV9uYW1lQg4KDF9zYW1wbGVfdHlwZUITChFfd2VsbF9yZWFkX3N0YXR1c0ILCglfZGlsdXRpb25iBnByb3RvMw", [file_quanterix_common_extensions_v1_field_options, file_quanterix_common_types_v1_sample_type, file_quanterix_common_types_v1_well_read_status]);

/**
 * Represents the configuration of a single plate well as-prepared during
 * experimental setup for processing on a SimoaOne instrument. This message
 * contains information that associates a given well with its analysis
 * parameters and inputs
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.PlateWellConfig
 */
export type PlateWellConfig = Message<"quanterix.simoa_one.analysis_app_api.v1.PlateWellConfig"> & {
  /**
   * Unique id (UUID) of this object
   *
   * @generated from field: optional string id = 1;
   */
  id?: string;

  /**
   * Human-readable well address, unique within a single plate. Typically in
   * the format A01-H12 for a 96-well plate
   *
   * @generated from field: optional string well_address = 2;
   */
  wellAddress?: string;

  /**
   * Unique id (UUID) of the assay assigned to this well for analysis
   *
   * @generated from field: optional string assay_id = 3;
   */
  assayId?: string;

  /**
   * Human-friendly name of the assay for display
   *
   * @generated from field: optional string assay_name = 4;
   */
  assayName?: string;

  /**
   * Unique id (UUID) of the sample (i.e. Calibrator, Control, Unknown)
   * assigned to this well. This id is used to identify groups of replicates
   *
   * @generated from field: optional string sample_id = 5;
   */
  sampleId?: string;

  /**
   * Human-friendly name of the sample for display
   *
   * @generated from field: optional string sample_name = 6;
   */
  sampleName?: string;

  /**
   * Sample type (i.e. Calibrator, Control, Unknown). This field is used to
   * display additional context information in graphical and table views
   *
   * @generated from field: optional quanterix.common.types.v1.SampleType sample_type = 7;
   */
  sampleType?: SampleType;

  /**
   * Indicates the read status of the well, derived from associated instrument
   * data.
   *
   * @remarks This field is expected to be unset until instrument data has been
   * added to the experiment.
   *
   * @generated from field: optional quanterix.common.types.v1.WellReadStatus well_read_status = 8;
   */
  wellReadStatus?: WellReadStatus;

  /**
   * The dilution of the sample in this well as-prepared for the experiment
   *
   * @generated from field: optional double dilution = 9;
   */
  dilution?: number;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.PlateWellConfig.
 * Use `create(PlateWellConfigSchema)` to create a new message.
 */
export const PlateWellConfigSchema: GenMessage<PlateWellConfig> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_plate_well_config, 0);

